export const adjustCinemaArrowHeight = (cinema) => {
    const cinemaTileHeight = cinema.querySelector(".reco_cinema__image")?.getBoundingClientRect().height * 0.52;
    if (cinemaTileHeight > 0) cinema.setAttribute("arrow-button-position", cinemaTileHeight + "px");
};
